import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: "",
    authenticated: false,
    user: {},
    pasien: {
      id_pasien: '',
      nomor_rekam_medis : '',
      nama_pasien : '',
      jenis_kelamin_pasien : '',
      tipe_pasien : '',
      no_telepon_pasien : '',
      tanggal_lahir_pasien : '',
      nomor_identitas_pasien : '',
      email_pasien : '',
      agama_pasien : '',
      pendidikan_pasien : '',
      pekerjaan_pasien : '',
      catatan_pasien : [],
      alamat_pasien : '',
      alamat_domisili_pasien: '',
      foto_pasien : '',
      id_istri_pasien: '',
      nama_istri_pasien : '',
      alamat_istri_pasien : '',
      alamat_domisili_istri_pasien: '',
      nomor_telepon_istri_pasien : '',
      tanggal_lahir_istri_pasien : '',
      nomor_identitas_istri_pasien : '',
      email_istri_pasien : '',
      agama_istri_pasien : '',
      pendidikan_istri_pasien : '',
      pekerjaan_istri_pasien : '',
      catatan_istri_pasien : [],
      foto_istri_pasien : '',
      id_suami_pasien: '',
      nama_suami_pasien : '',
      alamat_suami_pasien : '',
      alamat_domisili_suami_pasien: '',
      nomor_telepon_suami_pasien : '',
      tanggal_lahir_suami_pasien : '',
      nomor_identitas_suami_pasien : '',
      email_suami_pasien : '',
      agama_suami_pasien : '',
      pendidikan_suami_pasien : '',
      pekerjaan_suami_pasien : '',
      catatan_suami_pasien : [],
      foto_suami_pasien : '',
      id_admin_input : '',
      nama_admin_input : ''
    }
  },
  mutations: {
    setToken(state, accessToken) {
      state.token = accessToken
      state.authenticated = true
    },
    setUser(state, accessUser) {
      state.user = accessUser
    },
    setPatient(state, payload) {
      state.pasien = payload
    }
  },
  actions: {
  },
  modules: {
  }
})
